import { t } from "i18next";
import { useState } from "react";
import { ModalPopup } from "../ModalPopup/ModalPopup";
import { TextInput } from "@src/components/ui-components/Inputs/TextInput/TextInput";

export type RenameFilePopupProps = {
  id: string;
  defaultFileName: string;
  fileType: string | undefined | null;
  handleSave: (name: string) => void;
};

const getFileName = (fullFilename: string) => {
  const nameSeparatorIndex = fullFilename.lastIndexOf(".");

  if (nameSeparatorIndex > -1) {
    return fullFilename.slice(0, nameSeparatorIndex);
  }

  return fullFilename;
};

export const RenameFilePopup = ({ id, defaultFileName, fileType, handleSave }: RenameFilePopupProps) => {
  const [filename, setFilename] = useState(getFileName(defaultFileName));

  const onRename = () => {
    if (filename) {
      const type = fileType?.toLowerCase();

      handleSave(`${filename}${type ? "." + type : ""}`);
    }
  };

  return (
    <ModalPopup
      id={id}
      title={t("main.editFileName")}
      onActionClicked={onRename}
      disableAction={!filename}
      children={
        <div>
          <TextInput
            placeholder={t("main.enterAName")}
            value={filename}
            onChange={setFilename}
            style={{ width: "100%" }}
            rightText={fileType ? "." + fileType : ""}
          />
        </div>
      }
    />
  );
};
